import ManagementCalcRuleParamHist from './management-calculation-rules-parameter-history.entity';

export default class ManagementCalculationRuleHistory {
  rule: string;

  number: number;

  status: string;

  version: number;

  parameters: ManagementCalcRuleParamHist[];

  constructor(obj: any = {}) {
    this.rule = obj.rule || '';
    this.number = obj.number || 0;
    this.status = obj.status || '';
    this.version = obj.version || 0;
    if (obj.parameters) {
      this.parameters = ManagementCalcRuleParamHist.ofList(obj.parameters) || [];
    } else {
      this.parameters = [];
    }
  }

  public static of(obj: any = {}): ManagementCalculationRuleHistory {
    return new ManagementCalculationRuleHistory(obj);
  }

  public static ofList(obj: any[]): ManagementCalculationRuleHistory[] {
    return obj.map(this.of);
  }
}
